export function navigate(sectionId) {
  const section = document.getElementById(sectionId);

  if (section) {
    const offsetTop = section.offsetTop;
    const scrollOptions = {
      behavior: "smooth",
    };

    window.scrollTo({
      top: offsetTop,
      ...scrollOptions,
    });
  }
}
